import { Button, Space, Tag, Tooltip } from "antd";
import { paymentStatus } from "../options";
import { convertTimeStamp } from "utility/functions/convertTimestamp";

export const Columns = ({
  fetchDetail,
  order,
  handleReturnTicket,
  handleExchangeTicket,
}) => [
  {
    title: "狀態",
    dataIndex: "status",
    key: "status",
    render: (text, record) => (
      <>
        <span
          className={`text-white rounded-md px-2 ${
            text == 4
              ? "bg-green-500"
              : text == 64
              ? "bg-SKF-G-002"
              : "bg-red-500"
          }`}
        >
          {paymentStatus.find((item) => item.value == text)?.label}
        </span>
        {record?.enableSwitchPolicy && (
          <div>
            <Tag color="blue" className="mt-2 mb-1">
              換票開放時間
              <p className="text-[12px]">
                {convertTimeStamp(record?.switchPolicyStartDateTime)}
                {" - "}
                {convertTimeStamp(record?.switchPolicyEndDateTime)}
              </p>
            </Tag>
          </div>
        )}
        {record?.enableRefundPolicy && (
          <div>
            <Tag color="red">
              退票開放時間
              <p className="text-[12px]">
                {convertTimeStamp(record?.refundPolicyStartDateTime)}
                {" - "}
                {convertTimeStamp(record?.refundPolicyEndDateTime)}
              </p>
            </Tag>
          </div>
        )}
      </>
    ),
  },
  {
    title: "票號",
    dataIndex: "id",
    key: "id",
    width: 120,
    ellipsis: true,
    render: (text) => (
      <Tooltip title={text}>
        <span className="block max-w-[120px] truncate">{text}</span>
      </Tooltip>
    ),
  },
  {
    title: "價格",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "票券名稱",
    dataIndex: "title",
    key: "title",
    width: 180,
    ellipsis: true,
    render: (text) => (
      <Tooltip title={text}>
        <span className="block max-w-[180px] truncate">{text}</span>
      </Tooltip>
    ),
  },
  {
    title: "參加者",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 120,
    ellipsis: true,
    render: (text) => (
      <Tooltip title={text}>
        <span className="block max-w-[120px] truncate">{text}</span>
      </Tooltip>
    ),
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    render: (text, record) => (
      <Space>
        <Button
          type="link"
          className="text-left decoration-solid p-0"
          onClick={() => fetchDetail(record)}
        >
          詳情
        </Button>
        {record?.enableRefundPolicy && (
          <Button
            size="small"
            type="primary"
            className="h-auto text-left rounded-lg"
            loading={record?.isReturnBtnLoading}
            onClick={() => {
              handleReturnTicket(record);
            }}
          >
            退票
          </Button>
        )}
        {record?.enableSwitchPolicy && (
          <Button
            size="small"
            type="primary"
            className="h-auto text-left rounded-lg"
            loading={record?.isExchangeBtnLoading}
            onClick={() => {
              handleExchangeTicket(record);
            }}
          >
            換票
          </Button>
        )}
      </Space>
    ),
  },
];

export const Columns_mobile = ({
  fetchDetail,
  order,
  handleReturnTicket,
  handleExchangeTicket,
}) => [
  {
    title: "狀態",
    dataIndex: "status",
    key: "status",
    width: 88,
    render: (text) => (
      <span
        className={`text-white text-xs rounded-md px-2 py-0.5 whitespace-nowrap ${
          text == 4
            ? "bg-green-500"
            : text == 64
            ? "bg-SKF-G-002"
            : "bg-red-500"
        }`}
      >
        {paymentStatus.find((item) => item.value == text)?.label}
      </span>
    ),
  },
  {
    title: "票號",
    dataIndex: "id",
    key: "id",
    render: (text) => (
      <span className="text-xs text-SKF-G-003 break-all">{text}</span>
    ),
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    width: 64,
    render: (_, record) => (
      <Space direction="vertical" size={4} className="w-full">
        <Button
          type="link"
          className="p-0 h-auto text-xs"
          onClick={() => fetchDetail(record)}
        >
          詳情
        </Button>
        {record?.enableRefundPolicy && (
          <Button
            size="small"
            type="primary"
            className="h-auto text-xs rounded-lg"
            loading={record?.isReturnBtnLoading}
            onClick={() => handleReturnTicket(record)}
          >
            退票
          </Button>
        )}
        {record?.enableSwitchPolicy && (
          <Button
            size="small"
            type="primary"
            className="h-auto text-xs rounded-lg"
            loading={record?.isExchangeBtnLoading}
            onClick={() => handleExchangeTicket(record)}
          >
            換票
          </Button>
        )}
      </Space>
    ),
  },
];
